import '.e{display:flex;}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.at{opacity:0.5;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import '.cw{margin-top:1px;}.ssr-plugin'
import { styled } from 'inlines'
import { Icon } from '../assets/icons/index.js'
import { TABLET } from '../utils/breakpoints.js'

export const InfoRow = ({ children }: { children: React.ReactNode }) => (
  <styled.div className="e cv cc bn"
    style={{
      [TABLET]: { marginBottom: 16 },
    }}
  >
    <Icon
      type="infoIcon"
      style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
    />
    <p className="at ce cw">
      {children}
    </p>
  </styled.div>
)
